
import { WeightUnits } from '../logistic/weight-units.model';
import { OrderShippingAddress } from './shipping-address-request.model';
import { OrderShippingPackage } from './shipping-package-request.model';
import { OrderShippingPickup } from './shipping-pickup-details-request.model';

export class OrderShippingDetails {
  carrierServiceName?: string;
  carrierServiceCode?: string;
  isDryIceShipment?: boolean;
  isPickUpRequired?: boolean;
  isReturnShipmentOpted?: boolean;
  estimatedPrice?: number;
  billingCurrencyCode?: string;
  packageDetails?: OrderShippingPackage[];
  pickupDetail?: OrderShippingPickup;
  address?: OrderShippingAddress;
  dryIceWeight?: number;
  dryIceWeightUnit: WeightUnits;
  isPickupRequired: boolean;
  translationTag?: string;
}
